var map = {
	"./About": 341,
	"./About.jsx": 341,
	"./Error404": 491,
	"./Error404.jsx": 491,
	"./Home": 12,
	"./Home.jsx": 12,
	"./Layout": 896,
	"./Layout.jsx": 896,
	"./Pages": 123,
	"./Pages.jsx": 123,
	"./Payment": 158,
	"./Payment.jsx": 158,
	"./md/credits.md": 187,
	"./md/terms.md": 775,
	"pages/About": 341,
	"pages/About.jsx": 341,
	"pages/Error404": 491,
	"pages/Error404.jsx": 491,
	"pages/Home": 12,
	"pages/Home.jsx": 12,
	"pages/Layout": 896,
	"pages/Layout.jsx": 896,
	"pages/Pages": 123,
	"pages/Pages.jsx": 123,
	"pages/Payment": 158,
	"pages/Payment.jsx": 158,
	"pages/md/credits.md": 187,
	"pages/md/terms.md": 775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 954;